import type { AnalyticsTab } from "@/components/pages/analytics/config/analyticsTabs";

const FORWARDED_QUERY_PARAMS = new Set([
  "tenantId",
  "analyticsFrom",
  "analyticsTo",
  "segment",
  "offersStage",
  "reviewsSegment",
  "teamSegment",
]);

export function buildAdminHotelAnalyticsUrl(
  tab: AnalyticsTab,
  currentSearchParams: URLSearchParams,
  hotelId?: string,
): string {
  const nextSearchParams = new URLSearchParams();

  nextSearchParams.set("tab", tab);

  for (const [key, value] of currentSearchParams.entries()) {
    if (FORWARDED_QUERY_PARAMS.has(key)) {
      nextSearchParams.set(key, value);
    }
  }

  if (!hotelId) {
    return `/analytics?${nextSearchParams.toString()}`;
  }

  return `/analytics/hotels/${hotelId}?${nextSearchParams.toString()}`;
}
